import { render, staticRenderFns } from "./changeclass.vue?vue&type=template&id=55ab8f11"
import script from "./changeclass.vue?vue&type=script&lang=js"
export * from "./changeclass.vue?vue&type=script&lang=js"
import style0 from "./changeclass.vue?vue&type=style&index=0&id=55ab8f11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_react-dom@18.2.0_react@_xj7bp7fq6ppsfq3zomxsdbctue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports